export default {"src":"/_next/static/media/pencil_filled.a3d116bc.svg","height":24,"width":24};